module.exports = __webpack_public_path__ + "img/ES0216.88f12bb8.png";